let _audio = null;
let _unlocked = false;

function getAudio() {
  if (typeof window === 'undefined') return null;
  if (!_audio) {
    _audio = new Audio('/alert-chime.wav');
    _audio.preload = 'auto';
    _audio.volume = 0.7;
  }
  return _audio;
}

function playBeepFallback() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = 880;
    gain.gain.value = 0.08;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    setTimeout(() => {
      osc.stop();
      ctx.close?.();
    }, 180);
  } catch {
    /* ignore */
  }
}

/** Unlock audio on first user gesture (browsers block autoplay). */
export function initAudioUnlock() {
  if (typeof window === 'undefined' || _unlocked) return;
  const unlock = () => {
    const a = getAudio();
    if (a) {
      a.play()
        .then(() => {
          a.pause();
          a.currentTime = 0;
          _unlocked = true;
        })
        .catch(() => {
          playBeepFallback();
          _unlocked = true;
        });
    } else {
      playBeepFallback();
      _unlocked = true;
    }
    document.removeEventListener('click', unlock, true);
    document.removeEventListener('touchstart', unlock, true);
    document.removeEventListener('keydown', unlock, true);
  };
  document.addEventListener('click', unlock, true);
  document.addEventListener('touchstart', unlock, true);
  document.addEventListener('keydown', unlock, true);
}

export function playOrderAlertChime() {
  try {
    const a = getAudio();
    if (!a) {
      playBeepFallback();
      return;
    }
    a.currentTime = 0;
    a.play().catch(() => playBeepFallback());
  } catch {
    playBeepFallback();
  }
}
